import { Col, Container } from "react-bootstrap";
import LoadingIndicator from "../LoadingIndicator";
import ErrorResponse from "../ErrorResponse";
import useSortableData from "../useSortableData";
import Break from "../Breaks/Break";
import { useEffect, useMemo, useState } from "react";
import BreaksHeader from "../Breaks/BreaksHeader";
import { useLoaderData } from "react-router-dom";

export default function TopFlopBreaks({ formData, data, loading, error, dataPath }) {
    const { contentGroups } = useLoaderData();

    const [resolvedContentGroups, setResolvedContentGroups] = useState([]);
    const [breaksData, setBreaksData] = useState(null);

    useEffect(() => {
        if (data && data[dataPath]) {
            setBreaksData({ ...data, breaks: data[dataPath] });
        }
    }, [data, dataPath]);

    useEffect(() => {
        async function resolveContentGroups() {
            const groups = (await contentGroups).data ?? [];
            setResolvedContentGroups(groups);
        }
        resolveContentGroups();
    }, [contentGroups]);

    const filterFunction = useMemo(() => {
        if (!resolvedContentGroups.length || !formData?.station?.length) {
            return x => x.disabled === false;
        }

        const selectedRadioId = formData.station?.[0]?.radio_id ?? "";

        const overriddenIds = new Set(resolvedContentGroups.filter(g => g.override_for !== null && g.radio_id === selectedRadioId).map(g => g.override_for));

        return x => {
            const radioMatch = x.radio_id === selectedRadioId || x.radio_id === null;
            const notOverridden = !overriddenIds.has(x.group_id);
            return radioMatch && notOverridden && x.disabled === false;
        };
    }, [resolvedContentGroups, formData]);

    const { sortedItems, requestSort, sortConfig } = useSortableData(breaksData?.breaks);

    return (
        <div>
            {loading ? (
                <LoadingIndicator width={75} />
            ) : error ? (
                <ErrorResponse errorCode={error} />
            ) : (
                data &&
                data[dataPath] && (
                    <Col>
                        <BreaksHeader dataType={data.data_type} sortConfig={sortConfig} requestSort={requestSort} />
                        <Container fluid>
                            {sortedItems?.map(x => (
                                <Break
                                    key={x.break_id}
                                    formData={formData}
                                    radioId={data.radio_id}
                                    dataType={data.data_type}
                                    item={x}
                                    setBreaksData={setBreaksData}
                                    breaksDataPath={dataPath}
                                    filterFunction={filterFunction}
                                />
                            ))}
                        </Container>
                    </Col>
                )
            )}
        </div>
    );
}
